import type { PolymorphicVariantDef } from '@doer/frontend-components/creativity-editor';
import { buildTextIcon } from '../../_shared/text-icon';

// Variantes de payment-method-text. El polymorphic-binder monta/desmonta la activa.

const FONT = 'Avenir Next Rounded Pro';
const FILL = '#616365';

const cardVariant: PolymorphicVariantDef = {
  pieces: [
    {
      pieceId: 'payment-method-text',
      type: 'Textbox',
      version: '7.1.0',
      text: 'con Tarjeta de\nDébito BH',
      fontFamily: FONT,
      fontSize: 83,
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: 0.95,
      charSpacing: 0,
      textAlign: 'center',
      fill: FILL,
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1000.8507,
      width: 966.0228,
      selectable: true,
      evented: true,
      objectCaching: true
    }
  ],
  bindings: [{ pieceId: 'payment-method-text', bindingType: 'text', from: 'value' }]
};

const modoVariant: PolymorphicVariantDef = {
  pieces: [
    // Línea 1: "Pagando con" + logo Modo (imagen real) anclado a la derecha.
    ...buildTextIcon({
      pieceId: 'payment-method-modo-line1',
      text: 'Pagando con',
      icon: 'modo',
      fontSize: 83,
      fontFamily: FONT,
      fontWeight: 500,
      fill: FILL,
      position: { left: 540, top: 961 }
    }),
    // Línea 2: "desde App BH".
    {
      pieceId: 'payment-method-modo-line2',
      type: 'Textbox',
      version: '7.1.0',
      text: 'desde App BH',
      fontFamily: FONT,
      fontSize: 83,
      fontWeight: 500,
      fontStyle: 'normal',
      lineHeight: 0.95,
      charSpacing: 0,
      textAlign: 'center',
      fill: FILL,
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1040,
      width: 966.0228,
      selectable: true,
      evented: true,
      objectCaching: true
    }
  ],
  // Fijo: sin sub-campos ni bindings.
  bindings: []
};

export const PAYMENT_METHOD_VARIANTS = {
  card: cardVariant,
  modo: modoVariant
};
